/* Elements carrying .amble-reveal float up and fade in the first time they
   enter the viewport. Respects prefers-reduced-motion. */
(function () {
  var items = document.querySelectorAll('.amble-reveal');
  if (!items.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  /* an element laid out with display: contents has no box to watch, so its first
     child stands in for it */
  var owner = new Map();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      (owner.get(entry.target) || entry.target).classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });

  items.forEach(function (el) {
    var target = el;
    if (getComputedStyle(el).display === 'contents' && el.firstElementChild) {
      target = el.firstElementChild;
      owner.set(target, el);
    }
    io.observe(target);
  });
})();
